/*
 * 企業側 マイページ 提案募集状況 募集中の案件
 */
import { apiGetList } from '@/actions/ApiBaseActions';
export const API_GET_LIST_CLIENT_MY_PAGE_RFPS = 'API_GET_LIST_CLIENT_MY_PAGE_RFPS';
export const API_GET_LIST_CLIENT_MY_PAGE_RFPS_SUCCESS = 'API_GET_LIST_CLIENT_MY_PAGE_RFPS_SUCCESS';
/**
 * 一覧取得
 * @param page
 * @param meta
 * @returns
 */
export const apiGetListClientMyPageRfps = ({ query: { page } }, meta) => apiGetList(API_GET_LIST_CLIENT_MY_PAGE_RFPS, '/client/rfp', { page }, Object.assign(Object.assign({}, meta), { isSnakeCase: true }));
